import { render, staticRenderFns } from "./manageMCDetail.vue?vue&type=template&id=5844b739"
import script from "./manageMCDetail.vue?vue&type=script&lang=js"
export * from "./manageMCDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports